import { useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Delete, Edit, MoreVert, Pause, PlayArrow } from "@mui/icons-material";

// ----------------------------------------------------------------------

export default function MoreMenu({
  setOpenDeleteDialog,
  setOpenEditDialog,
  setOpenSuspendDialog,
  setOpenUnsuspendDialog,
  setRow,
  is_active,
  is_suspended
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <MoreVert />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            setOpenEditDialog(true);
            setRow();
          }}
          sx={{ color: "text.secondary" }}
        >
          <ListItemIcon>
            <Edit />
          </ListItemIcon>
          <ListItemText
            primary="Edit"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>

        {is_active && (
          <MenuItem
            sx={{ color: "text.secondary" }}
            onClick={() => {
              setOpenDeleteDialog(true);
              setRow();
            }}
          >
            <ListItemIcon>
              <Delete />
            </ListItemIcon>
            <ListItemText
              primary="Delete"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}

        {!is_suspended ? (
          <MenuItem
            sx={{ color: "text.secondary" }}
            onClick={() => {
              setOpenSuspendDialog(true);
              setRow();
            }}
          >
            <ListItemIcon>
              <Pause />
            </ListItemIcon>
            <ListItemText
              primary="Suspend"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        ) : (
          <MenuItem
            sx={{ color: "text.secondary" }}
            onClick={() => {
              setOpenUnsuspendDialog(true);
              setRow();
            }}
          >
            <ListItemIcon>
              <PlayArrow />
            </ListItemIcon>
            <ListItemText
              primary="Unsuspend"
              primaryTypographyProps={{ variant: "body2" }}
            />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
